export default function wp_sliders() {
  //Denna ska ha randomvisning, borde funka med flera på samma sida.
  const numOfImgs = $('.logo-slider .logos-logo').length;
  const randOmSlide = getRandom(numOfImgs);

  $('.logo-slider').slick({
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 5000,
    initialSlide: randOmSlide,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          infinite: true,
          centerPadding: '40px',
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          autoplay: false,
          infinite: false,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

if($('.gallery-carousel-container').length) {
  $('.gallery-carousel-container').slick({
  			dots: true,
  			arrows: false,
  			//adaptiveHeight: true,
  			autoplay: true,
  			autoplaySpeed: 3000
  		});
}

}

function getRandom(numImages) {
  return Math.floor(Math.random() * numImages);
}
